import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {StyleSheet} from "../../../stem-core/src/ui/Style.js";

import {MerchantButton} from "../../common/MerchantButton.jsx";
import {styleRule} from "../../../stem-core/src/decorators/Style.js";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {Messages} from "../../Messages.js";
import {authService, userService} from "../../../client/connection/Services.js";
import {StepDescription} from "./StepDescription.jsx";
import {Flow} from "../initializeFlows.js";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {PaymentMethodStore} from "../../State.js";
import {Link} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";
import {autoredraw} from "../../../stem-core/src/decorators/AutoRedraw.js";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../blink-sdk/utils/AnalyticsClient.js";
import {DonateComponent} from "../pages/panels/donation/components/DonateComponent.jsx";


class DonateStyle extends StyleSheet {
    @styleRule
    donateUpdateInfo = this.themeProps.INLINE_DONATE_FLOW_CHECKBOX;

    @styleRule
    center = {
        margin: "20px 0",
        textAlign: "center",
    };

    @styleRule
    link = this.themeProps.PANEL_LINK;
}

@autoredraw(iFrameUserDataService)
@registerStyle(DonateStyle)
export class DonatePanel extends UI.Element {
    continueCalled = false;

    render() {
        const {styleSheet} = this;
        StepDescription.stepCount = authService.isAuthenticated() ? 2 : 3;

        return [
            <StepDescription forwardFunction={this.continueCalled ? () => this.continue() : null}
                             currentStep={1} stepDescription={Messages.chooseAmount}/>,
            <DonateComponent onChange={() => this.redraw()}/>,
            <div className={styleSheet.donateUpdateInfo}>{Messages.donateUpdateInfo}</div>,
            <MerchantButton label={Flow.donation.getDonateComponentButtonLabel()}
                            onClick={() => this.continue()}
                            disabled={!Flow.donation.isValid()}/>,
            authService.isAuthenticated() ? null : <div className={styleSheet.center}>
                <Link className={styleSheet.link} onClick={() => this.continue()}>{Messages.alreadyDonor}</Link>
            </div>,
            <PoweredByBlink/>,
        ];
    }

    continue() {
        if (!this.continueCalled) {
            dispatchAnalyticsEvent(AnalyticsEventType.DONATE_SELECTED_AMOUNT, {
                amount: Flow.donation.donationAmount,
                frequency: Flow.donation.getFrequency().valueOf(),
                isCustomAmount: Flow.donation.isCustomAmount,
                coversFees: Flow.donation.payDonationFeeCheckboxChecked,
            });
        }
        this.continueCalled = true;
        this.options.changeURL(authService.isAuthenticated() ?
            (PaymentMethodStore.getPrimary() ? DONATE_PAGE_URLS.payWithChosenCard : DONATE_PAGE_URLS.payWithAddedCard)
            : DONATE_PAGE_URLS.auth);
    }

    onMount() {
        super.onMount();
        this.redraw(); // This is for the first rendering where the button doesn't have a label.
        authService.onAuthenticationChange(() => {
            if (this.isInDocument()) {
                if (authService.isAuthenticated()) {
                    LoadingSpinner.show();
                    userService.ensureUserDataRequested(() => {
                        LoadingSpinner.hide();
                        if (iFrameUserDataService.getActiveRecurringDonation()) {
                            this.options.changeURL(DONATE_PAGE_URLS.recurringDonor);
                        } else {
                            this.redraw();
                        }
                    });
                } else {
                    this.redraw();
                }
            }
        });
    }
}
